import {
  InteractionStepType,
  TURN_STANDARDIZED_QUALITY_MEASUREMENT_FIELDS,
  TASK_STANDARDIZED_QUALITY_MEASUREMENT_FIELDS,
} from '@scale/shared/types/chat';
import StringInputBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/StringInputBuilder';
import { TextCollectionField } from '@scale/shared/types/params/textcollection';
import FieldsBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/FieldsBuilder';
import { ReviewLevelConfig } from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/configs';
import { memo } from 'react';
import { StepConfigurationComponentProps } from '../stepDescriptor/types';
import { typeBuilderMap } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemas';

function QualityMeasurementConfigurationComponent({
  params: currentParams,
  setParams: setCurrentParams,
  property,
  deliveryBuilderConfig,
}: StepConfigurationComponentProps<InteractionStepType.QualityMeasurement>) {
  return (
    <div className="flex flex-col gap-4">
      <StringInputBuilder
        name={'Title'}
        existingValue={currentParams.title}
        updateProperty={() => {}}
        readOnly
      />

      <StringInputBuilder
        name={'Subtitle'}
        existingValue={currentParams.subtitle}
        updateProperty={() => {}}
        readOnly
      />

      <div className="font-medium">Fields</div>
      <FieldsBuilder
        typeBuilderMap={typeBuilderMap}
        name={''}
        stepId={currentParams.id}
        existingValue={currentParams.params.fields}
        updateProperty={(value: TextCollectionField[]) =>
          setCurrentParams({
            ...currentParams,
            params: { ...currentParams.params, fields: value },
          })
        }
        restrictedFields={
          property === 'turn'
            ? TURN_STANDARDIZED_QUALITY_MEASUREMENT_FIELDS
            : property === 'after'
            ? TASK_STANDARDIZED_QUALITY_MEASUREMENT_FIELDS
            : undefined
        }
        deliveryBuilderConfig={deliveryBuilderConfig}
      />

      <ReviewLevelConfig currentParams={currentParams} setCurrentParams={setCurrentParams} />
    </div>
  );
}

export default memo(QualityMeasurementConfigurationComponent);
